import { createFeature, createReducer, on } from '@ngrx/store';
import { BaseZoneWithParentsFragment } from 'graphql.generated';

import { ZonesActions } from './zones.actions';

export const zonesInitialState = {
	currentAppZone: undefined as BaseZoneWithParentsFragment | undefined,
} as const;

export type ZonesState = typeof zonesInitialState;

export const zonesFeature = createFeature({
	name: 'zones',
	reducer: createReducer(
		zonesInitialState,
		on(ZonesActions.zoneChanged, (state, res): ZonesState => {
			return {
				...state,
				currentAppZone: res.currentAppZone,
			}
		}),
	)
});
